import { DocIcon, PdfIcon } from '../assets';
import DocPdfIcon from '../assets/DocPdfIcon';

export const extractUrlParams = (paramName) => {
  const search = new URLSearchParams(window.location.search);
  return search.has(paramName) ? search.get(paramName) : '';
};

export function shortenStringWithEllipsis(inputString) {
  const maxLength = 25;

  if (inputString.length > maxLength) {
    // Shorten the string and add ellipsis
    return `${inputString.substring(0, maxLength)}....`;
  }
  // Return the original string if it's within the length limit
  return inputString;
}

export const comparisonType = (files) => {
  const flag = {
    DOCX: false,
    PDF: false,
  };
  files.forEach((f) => {
    if (f?.file_name?.includes('.docx')) {
      flag.DOCX = true;
    }
    if (f?.file_name?.includes('.pdf')) {
      flag.PDF = true;
    }
  });

  if (flag.PDF && flag.DOCX) {
    return <DocPdfIcon size={32} />;
  }
  if (flag.PDF) {
    return <PdfIcon size={32} />;
  }
  if (flag.DOCX) {
    return <DocIcon size={32} />;
  }
  // if (orgiginalfile?.includes('.docx') && modifiedfile?.includes('.docx')) {
  //   return 'DOCX';
  // } else if (
  //   orgiginalfile?.includes('.docx') &&
  //   modifiedfile?.includes('.pdf')
  // ) {
  //   return 'PDF_DOCX';
  // } else if (
  //   orgiginalfile?.includes('.pdf') &&
  //   modifiedfile?.includes('.docx')
  // ) {
  //   return 'PDF_DOCX';
  // } else if (
  //   orgiginalfile?.includes('.pdf') &&
  //   modifiedfile?.includes('.pdf')
  // ) {
  //   return 'PDF';
  // } else {
  //   return 'DOCX';
  // }
};

export const timeAgo = (timestamp) => {
  // Parse the ISO 8601 timestamp into a Date object
  const parsedDate = new Date(timestamp);

  // Check if the parsed date is valid
  if (Number.isNaN(parsedDate.getTime())) {
    return 'Invalid timestamp';
  }

  const now = Date.now();
  const diff = now - parsedDate.getTime();

  // Check if the difference is negative, indicating a future timestamp
  if (diff < 0) {
    return 'just now';
  }

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) {
    return 'just now';
  }
  if (minutes < 60) {
    return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
  }
  if (hours < 24) {
    return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
  }
  return `${days} day${days !== 1 ? 's' : ''} ago`;
};

export const copyToClipboard = async (text) => {
  if (text) {
    try {
      await navigator.clipboard.writeText(text);
      console.info('Copied to clipboard!');
      return true;
    } catch (error) {
      console.error('Failed to copy: ', error);
      return false;
    }
  } else {
    console.warn('No text provided to copy.');
  }
};

function replaceTagsWithSomeOtherTag(root, tags, replaceWithTag = 'div') {
  tags.forEach((tag) => {
    root.querySelectorAll(tag).forEach((el) => {
      const div = document.createElement(replaceWithTag);

      // copy attributes
      Array.from(el.attributes).forEach((attr) => {
        div.setAttribute(attr.name, attr.value);
      });

      // move children
      while (el.firstChild) {
        div.appendChild(el.firstChild);
      }

      el.replaceWith(div);
    });
  });

  return root;
}

function copyRichTextFallback(html) {
  const container = document.createElement('div');
  const clonedHTML = html.cloneNode(true);
  const result = replaceTagsWithSomeOtherTag(clonedHTML, ['ul', 'ol', 'li']);
  container.innerHTML = result.outerHTML;
  container.style.position = 'fixed';
  container.style.left = '-9999px';
  container.style.top = '0';

  document.body.appendChild(container);

  const range = document.createRange();
  range.selectNodeContents(container);

  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);

  document.execCommand('copy');

  selection?.removeAllRanges();
  document.body.removeChild(container);
}

export const copyToClipboardWithFormat = async (element) => {
  if (element) {
    if (!(navigator.clipboard && window.ClipboardItem)) {
      console.info('Copied to clipboard with fallback!');
      copyRichTextFallback(element);
      return true;
    }
    try {
      const clonedHTML = element.cloneNode(true);
      const html = replaceTagsWithSomeOtherTag(clonedHTML, ['ul', 'ol', 'li']).outerHTML;
      const text = element.innerText;

      const clipboardItem = new ClipboardItem({
        'text/html': new Blob([html], { type: 'text/html' }),
        'text/plain': new Blob([text], { type: 'text/plain' }),
      });

      await navigator.clipboard.write([clipboardItem]);
      console.info('Copied to clipboard!');

      return true;
    } catch (error) {
      console.error('Failed to copy: ', error);
      return false;
    }
  } else {
    console.warn('No text provided to copy.');
    return false;
  }
};

export const getOrdinalSuffix = (day) => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const formatDateTime = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  const day = date.getDate();
  const month = date.toLocaleDateString('en-US', { month: 'long' });
  const year = date.getFullYear();
  const time = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(date);

  return `${day}${getOrdinalSuffix(day)} ${month} ${year}, ${time}`;
};
